var _defs, _rect, _g, _g2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-android",
    x1: 0.915,
    y1: 15.666,
    x2: -0.383,
    y2: 14.996,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-android-2",
    x1: 1.076,
    y1: 43.628,
    x2: -1.305,
    y2: 43.628,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-android-3",
    x1: 0.862,
    y1: 28.507,
    x2: -0.501,
    y2: 26.737,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-android-4",
    x1: -0.188,
    y1: 31.228,
    x2: 0.421,
    y2: 30.438,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(12.765 103.459)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12489",
    "data-name": "Rectangle 12489",
    width: 162,
    height: 48,
    rx: 5,
    transform: "translate(-12.765 -103.459)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74696",
    "data-name": "Group 74696",
    transform: "translate(-12.765 -103.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74695",
    "data-name": "Group 74695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65022",
    "data-name": "Path 65022",
    d: "M143.235-102.5a5.046,5.046,0,0,1,5.04,5.04v36a5.047,5.047,0,0,1-5.04,5.041h-150a5.047,5.047,0,0,1-5.04-5.041v-36a5.046,5.046,0,0,1,5.04-5.04h150m0-.96h-150a6.018,6.018,0,0,0-6,6v36a6.018,6.018,0,0,0,6,6h150a6.018,6.018,0,0,0,6-6v-36a6.018,6.018,0,0,0-6-6Z",
    transform: "translate(12.765 103.459)",
    fill: "#a6a6a6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_74697",
    "data-name": "Group 74697",
    transform: "translate(36.857 -95.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65023",
    "data-name": "Path 65023",
    d: "M35.867-92.541a3.248,3.248,0,0,1-.894,2.4,3.492,3.492,0,0,1-2.646,1.066,3.626,3.626,0,0,1-2.65-1.08,3.626,3.626,0,0,1-1.091-2.681,3.621,3.621,0,0,1,1.091-2.68,3.622,3.622,0,0,1,2.65-1.081,3.727,3.727,0,0,1,1.478.3,2.966,2.966,0,0,1,1.126.805l-.632.634a2.429,2.429,0,0,0-1.972-.854,2.733,2.733,0,0,0-1.966.8,2.754,2.754,0,0,0-.83,2.076,2.757,2.757,0,0,0,.83,2.077,2.738,2.738,0,0,0,1.966.8,2.729,2.729,0,0,0,2.011-.8,2.268,2.268,0,0,0,.6-1.459H32.327v-.864h3.49A3.083,3.083,0,0,1,35.867-92.541Z",
    transform: "translate(-28.587 96.593)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65024",
    "data-name": "Path 65024",
    d: "M39.964-95.573H36.685v2.282h2.957v.865H36.685v2.282h3.278v.884h-4.2v-7.2h4.2Z",
    transform: "translate(-27.152 96.62)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65025",
    "data-name": "Path 65025",
    d: "M43-89.259h-.925v-6.314H40.067v-.886h4.948v.886H43Z",
    transform: "translate(-26.291 96.62)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65026",
    "data-name": "Path 65026",
    d: "M47.173-89.259v-7.2H48.1v7.2Z",
    transform: "translate(-24.87 96.62)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65027",
    "data-name": "Path 65027",
    d: "M51.854-89.259h-.926v-6.314H48.916v-.886h4.948v.886h-2.01Z",
    transform: "translate(-24.521 96.62)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65028",
    "data-name": "Path 65028",
    d: "M61.9-90.162a3.537,3.537,0,0,1-2.641,1.091,3.53,3.53,0,0,1-2.639-1.091,3.682,3.682,0,0,1-1.061-2.67A3.679,3.679,0,0,1,56.622-95.5a3.527,3.527,0,0,1,2.639-1.092A3.532,3.532,0,0,1,61.9-95.5a3.677,3.677,0,0,1,1.064,2.664A3.69,3.69,0,0,1,61.9-90.162Zm-4.6-.6a2.641,2.641,0,0,0,1.955.81,2.64,2.64,0,0,0,1.956-.81,2.813,2.813,0,0,0,.8-2.066,2.815,2.815,0,0,0-.8-2.066,2.639,2.639,0,0,0-1.956-.809,2.64,2.64,0,0,0-1.955.809,2.819,2.819,0,0,0-.8,2.066A2.817,2.817,0,0,0,57.306-90.766Z",
    transform: "translate(-23.192 96.593)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65029",
    "data-name": "Path 65029",
    d: "M62.81-89.259v-7.2h1.127l3.5,5.6h.04l-.04-1.388v-4.213h.925v7.2H67.4l-3.661-5.872H63.7l.04,1.387v4.484Z",
    transform: "translate(-21.743 96.62)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65030",
    "data-name": "Path 65030",
    d: "M60.79-80.766a5.03,5.03,0,0,0-5.123,5.1,5.042,5.042,0,0,0,5.123,5.1,5.042,5.042,0,0,0,5.123-5.1A5.03,5.03,0,0,0,60.79-80.766Zm0,8.2a2.953,2.953,0,0,1-2.88-3.094,2.94,2.94,0,0,1,2.88-3.094,2.941,2.941,0,0,1,2.881,3.094A2.954,2.954,0,0,1,60.79-72.569Zm-11.176-8.2a5.031,5.031,0,0,0-5.124,5.1,5.043,5.043,0,0,0,5.124,5.1,5.042,5.042,0,0,0,5.123-5.1A5.03,5.03,0,0,0,49.614-80.766Zm0,8.2a2.954,2.954,0,0,1-2.881-3.094,2.941,2.941,0,0,1,2.881-3.094,2.94,2.94,0,0,1,2.88,3.094A2.953,2.953,0,0,1,49.614-72.569ZM36.319-79.2v2.165H41.5a4.526,4.526,0,0,1-1.18,2.726,5.3,5.3,0,0,1-4,1.585,5.685,5.685,0,0,1-5.683-5.761,5.685,5.685,0,0,1,5.683-5.761,5.52,5.52,0,0,1,3.9,1.547l1.528-1.528a7.552,7.552,0,0,0-5.432-2.184,8.037,8.037,0,0,0-8.042,7.926,8.037,8.037,0,0,0,8.042,7.926,7.246,7.246,0,0,0,5.53-2.224,7.152,7.152,0,0,0,1.874-5.064,7.111,7.111,0,0,0-.115-1.354Zm54.369,1.681a4.743,4.743,0,0,0-4.369-3.247,4.85,4.85,0,0,0-4.813,5.1,4.994,4.994,0,0,0,5.065,5.1,5.076,5.076,0,0,0,4.253-2.262l-1.74-1.159a2.917,2.917,0,0,1-2.513,1.411A2.6,2.6,0,0,1,84.1-74.116l6.824-2.822Zm-6.959,1.7A2.8,2.8,0,0,1,86.4-78.795a1.979,1.979,0,0,1,1.895,1.082Zm-5.549,4.949h2.243v-15H78.181Zm-3.673-8.758H74.43a3.537,3.537,0,0,0-2.687-1.14,5.076,5.076,0,0,0-4.891,5.123,5.054,5.054,0,0,0,4.891,5.084,3.48,3.48,0,0,0,2.687-1.159h.078v.734c0,1.952-1.044,3-2.726,3a2.821,2.821,0,0,1-2.57-1.818l-1.954.812a4.865,4.865,0,0,0,4.524,3.016c2.629,0,4.853-1.546,4.853-5.316v-9.163H74.508Zm-2.572,7.057a2.929,2.929,0,0,1-2.842-3.074,2.952,2.952,0,0,1,2.842-3.113,2.877,2.877,0,0,1,2.726,3.113A2.853,2.853,0,0,1,71.937-72.569Zm29.257-13.3H95.828v15h2.239v-5.683h3.126a4.753,4.753,0,0,0,4.921-4.66A4.752,4.752,0,0,0,101.194-85.87Zm.058,7.23H98.068v-5.142h3.184a2.6,2.6,0,0,1,2.626,2.57A2.614,2.614,0,0,1,101.251-78.64Zm13.838-2.154a4.2,4.2,0,0,0-3.995,2.3l1.987.829a2.123,2.123,0,0,1,2.046-1.1,2.156,2.156,0,0,1,2.354,1.93v.155a4.947,4.947,0,0,0-2.335-.58c-2.142,0-4.322,1.177-4.322,3.378a3.466,3.466,0,0,0,3.725,3.3,3.159,3.159,0,0,0,2.856-1.466h.077v1.158h2.162v-5.752C119.645-79.308,117.656-80.794,115.09-80.794Zm-.27,8.221c-.733,0-1.757-.366-1.757-1.273,0-1.158,1.274-1.6,2.375-1.6a3.986,3.986,0,0,1,2.045.5A2.713,2.713,0,0,1,114.82-72.573Zm12.7-7.894-2.567,6.5h-.078l-2.663-6.5H119.8l4,9.09-2.278,5.057h2.335l6.156-14.147Zm-20.168,9.6h2.238v-15h-2.238Z",
    transform: "translate(8.208 3.41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74699",
    "data-name": "Group 74699",
    transform: "translate(-0.797 -94.89)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65031",
    "data-name": "Path 65031",
    d: "M-2.236-95.907a2.4,2.4,0,0,0-.556,1.686v26.539A2.4,2.4,0,0,0-2.236-66l.089.086L12.719-80.776v-.35L-2.148-95.993Z",
    transform: "translate(2.792 96.384)",
    fill: "url(#linear-gradient-android)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65032",
    "data-name": "Path 65032",
    d: "M15.089-77.469l-4.955-4.958v-.35l4.956-4.956.112.064,5.872,3.336c1.678.953,1.678,2.512,0,3.466L15.2-77.533Z",
    transform: "translate(5.377 98.035)",
    fill: "url(#linear-gradient-android-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65033",
    "data-name": "Path 65033",
    d: "M17.694-78.389l-5.068-5.069L-2.329-68.5a1.952,1.952,0,0,0,2.494.074l17.53-9.961",
    transform: "translate(2.885 98.891)",
    fill: "url(#linear-gradient-android-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65034",
    "data-name": "Path 65034",
    d: "M17.694-85.955.165-95.915a1.952,1.952,0,0,0-2.494.073L12.627-80.886Z",
    transform: "translate(2.885 96.319)",
    fill: "url(#linear-gradient-android-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74698",
    "data-name": "Group 74698",
    transform: "translate(0 20.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65035",
    "data-name": "Path 65035",
    d: "M17.583-79.327.165-69.431a2,2,0,0,1-2.4.013h0l-.089.09h0l.089.086h0a2,2,0,0,0,2.4-.012l17.53-9.961Z",
    transform: "translate(2.885 79.327)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65036",
    "data-name": "Path 65036",
    d: "M-2.236-70.859a2.4,2.4,0,0,1-.556-1.686v.175a2.4,2.4,0,0,0,.556,1.686l.089-.09Z",
    transform: "translate(2.792 80.683)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65037",
    "data-name": "Path 65037",
    d: "M20.247-81.9l-5.983,3.4.112.112,5.872-3.336A2.1,2.1,0,0,0,21.5-83.457h0A2.234,2.234,0,0,1,20.247-81.9Z",
    transform: "translate(6.203 98.891)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65038",
    "data-name": "Path 65038",
    d: "M.257-95.74l23.4,13.3a2.233,2.233,0,0,1,1.258,1.558h0a2.1,2.1,0,0,0-1.258-1.733l-23.4-13.3c-1.678-.953-3.049-.161-3.049,1.76v.175C-2.792-95.9-1.42-96.692.257-95.74Z",
    transform: "translate(2.792 96.318)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.e4b73ff17f904daec344c36d92b82af2.svg";
export { ForwardRef as ReactComponent };